// ユーザー詳細.
import * as React from 'react';
import * as UserListField from '../../constants/UserListField';

// ローディング中のダミー・利用者の詳細.
export class DummyUserDetail extends React.Component {
  render() {
    return(
      <div className="user">
        <p />
        <p />
        <p />
        <p />
      </div>
    );
  }
}

// 利用者の詳細props
interface UserDetailProps extends React.Props<{}> {
  user: UserListField.User;
}

// 利用者の詳細表示用コンポーネント
export default class UserDetail extends React.Component<UserDetailProps, {}> {
  render() {
    if (typeof this.props.user === 'undefined') {
      return(
        <div className="user">
          <p>Error</p>
          <p />
          <p />
          <p />
        </div>
      );
    }

    return (
      <div className="user">
        <p id="userCareId">{this.props.user.user_care_id}</p>
        <p>{this.props.user.user_name}</p>
        <p>{this.props.user.user_birth_year}</p>
        <p>{this.props.user.user_gender === 0 ? UserListField.Male : UserListField.Female}</p>
        {/* <p>{institution.institution_name}</p> */}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/UserDetail.tsx